module.exports = __webpack_public_path__ + "static/media/stage3@2x.ff69a92f.webp";